import React, { useState } from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/messages';
import { translate } from 'containers/services/translate';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import EmptyAddFormBloc from 'components/EmptyAddFormBloc';
import { Wrapper } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/styled-components';
import IncomeCertificatesForm from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/IncomeCertificatesForm';
import { VictimType } from 'typings/globalTypes';
import { Listings } from 'containers/AppContainer/typings';
import { ClaimRecapType } from 'typings/claimTypes';

export interface IncomeCertificateProps {
  intl: IntlShape;
  victims: VictimType[];
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  sagisVictimInfo: any;
  requestCreateIncomeCertificate?: Function;
  isManager: Boolean;
  setDocumentId: Function;
  documentId: any;
  claimId: number;
  claimNumber: string;
  judiciaryProcessId: any;
  dahirAmount: [];
  riskKey: string;
  claim: ClaimRecapType;
  listings: Listings;
}

const IncomeCertificate: React.FC<IncomeCertificateProps> = (
  props,
): JSX.Element => {
  const [isIncomeCertificateFormOn, setIsIncomeCertificateFormOn] = useState<
    boolean
  >(false);

  const handleAddButton = () => {
    setIsIncomeCertificateFormOn(true);
  };
  const [incomeCertificates, setIncomeCertificates] = useState({} as any);
  return (
    <Wrapper>
      <section className="content">
        <div className="pronounce-add-bloc-title">
          {translate(messages.judgementAddIncomeCertificateTitle, props)}
        </div>
        {!isIncomeCertificateFormOn && (
          <EmptyAddFormBloc
            title={translate(
              messages.judgementAddIncomeCertificateSubtitle,
              props,
            )}
            buttonBlocTitle={translate(
              messages.judgementAddPronouncingButtonTitle,
              props,
            )}
            icon={<AddCircleOutlineIcon className="icon" />}
            handleClick={handleAddButton}
          />
        )}
        {isIncomeCertificateFormOn && (
          <IncomeCertificatesForm
            victims={props.victims}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            resetUploadedDocument={props.resetUploadedDocument}
            sagisVictimInfo={props.sagisVictimInfo}
            requestCreateIncomeCertificate={
              props.requestCreateIncomeCertificate
            }
            isManager={props.isManager}
            setDocumentId={props.setDocumentId}
            documentId={props.documentId}
            claimNumber={props.claimNumber}
            claimId={props.claimId}
            riskKey={props.riskKey}
            incomeCertificates={incomeCertificates}
            setIncomeCertificates={setIncomeCertificates}
            judiciaryProcessId={props.judiciaryProcessId}
            dahirAmount={props.dahirAmount}
            setIsIncomeCertificateFormOn={setIsIncomeCertificateFormOn}
            claim={props.claim}
            listings={props.listings}
          />
        )}
      </section>
    </Wrapper>
  );
};

export default injectIntl(IncomeCertificate);
